import { render, staticRenderFns } from "./Profile-3.vue?vue&type=template&id=51269070"
import script from "./Profile-3.vue?vue&type=script&lang=js"
export * from "./Profile-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports